import React, {Component} from 'react'
import AdminFilterForm from "./TableFilters/AdminFilterForm";
import Loader from "../Simple/Loader";
import AdminColumnToggle from "./Fields/AdminColumnToggle";
import SearchField from "./Fields/SearchField";
import ViewTypeField from "./Fields/ViewTypeField";
import ActionButtons from "./Fields/ActionButtons";
import GlobalFilters from "./Fields/GlobalFilters";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import withMobileDialog from "@material-ui/core/withMobileDialog";
import PropTypes from 'prop-types';
import SettingsDialog from "./Fields/SettingsDialog";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

class FilterContainer extends Component {
  state = {
    open: false,
  };
  handleClickOpen = () => {
    this.setState({open: true});
  };

  handleClose = () => {
    this.setState({open: false});
  };

  render() {
    const {
      fullScreen,
      viewType,
      childViewType,
      onSearchChanged,
      handleSearchSubmit,
      onViewTypeSelect,
      checkedChildColumns,
      checkedColumns,
      onAddFilter,
      onRemoveFilter,
      filters,
      savedFilters,
      onSetSavedFilters,
      onSaveFilters,
      onRemoveSavedFilters,
      availableColumns,
      showChilds,
      showChildHeader,
      updateStatsCache,
      onFileExport,
      availableChildColumns,
      country,
      onCountrySelect,
      onLimitSelect,
      onColumnChange,
      search,
      toggleShowChildren,
      update,
      toggleChildHeader,
      cacheUpdating,
      limit
    } = this.props

    return (<>
          <div className="row">
            <div className="col-12">
              <AdminFilterForm
                  filters={filters}
                  columns={availableColumns}
                  onRemoveFilter={onRemoveFilter}
                  onSubmit={onAddFilter}
                  savedFilters={savedFilters}
                  onSetSavedFilters={onSetSavedFilters}
                  onSaveFilters={onSaveFilters}
                  onRemoveSavedFilters={onRemoveSavedFilters}
                  handleSearchSubmit={handleSearchSubmit}
                  onSearchChanged={onSearchChanged}
                  search={search}
                  fullScreen={fullScreen}
                  open={this.state.open}
                  handleClose={this.handleClose}
                  viewType={viewType}
                  onViewTypeSelect={onViewTypeSelect}
                  childViewType={childViewType}
                  availableColumns={availableColumns}
                  onColumnChange={onColumnChange}
                  checkedColumns={checkedColumns}
                  availableChildColumns={availableChildColumns}
                  checkedChildColumns={checkedChildColumns}
                  limit={limit}
                  onLimitSelect={onLimitSelect}
                  country={country}
                  onCountrySelect={onCountrySelect}
                  showChilds={showChilds}
                  toggleShowChildren={toggleShowChildren}
                  showChildHeader={showChildHeader}
                  toggleChildHeader={toggleChildHeader}
                  filters={filters}
                  cacheUpdating={cacheUpdating}
                  onFileExport={onFileExport}
                  updateStatsCache={updateStatsCache}
                  update={update}
                  handleClickOpen={this.handleClickOpen}
              />
            </div>
          </div>
        </>
    )
  }
}

FilterContainer.propTypes = {
  fullScreen: PropTypes.bool.isRequired,
};

export default withMobileDialog()(FilterContainer);
